import { useQuery } from '@tanstack/react-query';

import { SatelliteCreditsUsageResponse } from '@/api/credits/types';
import { useDisplayPreferences } from '@/api/userAccount';
import { RequestOptions, axios } from '@/common/axios';
import { QueryConfig } from '@/common/react-query';
import { SATELLITE_CREDITS_USAGE_HISTORY_QUERY_KEY } from '@/config';

type GetSatelliteCreditsUsageParams = {
    from: string;
    tz?: string;
};

export const getSatelliteCreditsUsage = async (params: GetSatelliteCreditsUsageParams, options?: RequestOptions) => {
    return axios.get<SatelliteCreditsUsageResponse, SatelliteCreditsUsageResponse>(
        '/api/v2/customers/satellite-credits-history',
        {
            params,
            ...options,
        }
    );
};

type UseSatelliteCreditsUsageHistoryOptions = GetSatelliteCreditsUsageParams & {
    config?: QueryConfig<typeof getSatelliteCreditsUsage>;
};

export const useSatelliteCreditsUsageHistory = ({
    config: { enabled = true, ...config } = {},
    ...params
}: UseSatelliteCreditsUsageHistoryOptions) => {
    const { data: displayPreferences } = useDisplayPreferences();
    if (!params.tz && displayPreferences) {
        if (displayPreferences.timeZone === 'UTC') {
            params.tz = 'UTC';
        } else {
            params.tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        }
    }
    return useQuery({
        ...config,
        enabled: enabled && !!params.tz,
        queryKey: [SATELLITE_CREDITS_USAGE_HISTORY_QUERY_KEY, params],
        queryFn: ({ signal }) => getSatelliteCreditsUsage(params, { signal }),
        staleTime: 1000 * 60 * 15, // 15 minutes
    });
};
